import $ from 'jquery';

$(() => {
  let annonceurWeight = 0;
  let site1Weight = 0;
  let site2Weight = 0;
  let site3Weight = 0;
  let scn2Weight = 0;
  let scn3Weight = 0;
  let scn4Weight = 0;
  let scn5Weight = 0;

  const $annonceurEl = $('#annonceur');
  const $site1El = $('#site1');
  const $site2El = $('#site2');
  const $site3El = $('#site3');

  if (!$annonceurEl.length || !$site1El.length || !$site2El.length || !$site3El.length) {
    return;
  }

  function calculateCommissions(): void {
    annonceurWeight = parseInt($('#annonceur').val() as string, 10);
    site1Weight = parseInt($('#site1').val() as string, 10);
    site2Weight = parseInt($('#site2').val() as string, 10);
    site3Weight = parseInt($('#site3').val() as string, 10);

    $('#annonceur-value').text(annonceurWeight);
    $('#site1-value').text(site1Weight);
    $('#site2-value').text(site2Weight);
    $('#site3-value').text(site3Weight);

    scn2Weight = annonceurWeight + site1Weight;
    $('#annonceur-sc2-amount').text(Math.round(((annonceurWeight * 10) / scn2Weight) * 100) / 100);
    $('#site1-sc2-amount').text(Math.round(((site1Weight * 10) / scn2Weight) * 100) / 100);

    scn3Weight = annonceurWeight + site1Weight + site2Weight;
    $('#annonceur-sc3-amount').text(Math.round(((annonceurWeight * 10) / scn3Weight) * 100) / 100);
    $('#site1-sc3-amount').text(Math.round(((site1Weight * 10) / scn3Weight) * 100) / 100);
    $('#site2-sc3-amount').text(Math.round(((site2Weight * 10) / scn3Weight) * 100) / 100);

    scn4Weight = annonceurWeight + site1Weight + site2Weight + site3Weight;
    $('#annonceur-sc4-amount').text(Math.round(((annonceurWeight * 10) / scn4Weight) * 100) / 100);
    $('#site1-sc4-amount').text(Math.round(((site1Weight * 10) / scn4Weight) * 100) / 100);
    $('#site2-sc4-amount').text(Math.round(((site2Weight * 10) / scn4Weight) * 100) / 100);
    $('#site3-sc4-amount').text(Math.round(((site3Weight * 10) / scn4Weight) * 100) / 100);

    scn5Weight = site1Weight + site2Weight + site3Weight;
    $('#site1-sc5-amount').text(Math.round(((site1Weight * 10) / scn5Weight) * 100) / 100);
    $('#site2-sc5-amount').text(Math.round(((site2Weight * 10) / scn5Weight) * 100) / 100);
    $('#site3-sc5-amount').text(Math.round(((site3Weight * 10) / scn5Weight) * 100) / 100);
  }

  calculateCommissions();

  $('input[name="annonceur"], input[name="site1"], input[name="site2"], input[name="site3"]').on('input', () => {
    calculateCommissions();
  });
});
